import DevChampsInfoRs, { DevChampsInfoDto } from '@domain/rs/dchamps/DevChampsInfoRs';
import { DchampsEventMothText, DchampsEventType } from '@domain/constant/dchamps/eventType';
import { DchampsStageType } from '@domain/constant/dchamps/stageType';
import DchampsStatusType from '@domain/constant/dchamps/statusType';
import DateUtil from '@utils/date/util';

class DevChampsInfoListVO {
  devChampsInfoDtos: DevChampsInfoVO[];
  progressQualify?: DevChampsInfoVO;
  progressFinal?: DevChampsInfoVO;

  constructor(rs: DevChampsInfoRs) {
    this.devChampsInfoDtos = rs.devChampsInfoDtos.map((dto) => new DevChampsInfoVO(dto));
    this.progressQualify = this.devChampsInfoDtos.find((vo) => vo.dchampsStatusType === 'IN_QUALIFY');
    this.progressFinal = this.devChampsInfoDtos.find((vo) =>
      ['BEFORE_FINAL', 'IN_FINAL'].includes(vo.dchampsStatusType),
    );
  }

  static getCountInfo(vo?: DevChampsInfoVO, dchampsStatusType?: DchampsStatusType) {
    if (!vo) return null;

    if (dchampsStatusType === 'IN_QUALIFY')
      return {
        countDate: vo.endDateTime,
        headerText: `${DchampsEventMothText[vo.eventType]}월 예선 마감까지`,
      };
    else if (dchampsStatusType === 'BEFORE_FINAL')
      return {
        countDate: vo.startDateTime,
        headerText: `${DchampsEventMothText[vo.eventType]}월 본선 시작까지`,
      };
    return {
      countDate: vo.endDateTime,
      headerText: `${DchampsEventMothText[vo.eventType]}월 본선 마감까지`,
    };
  }
}

class DevChampsInfoVO {
  eventType: DchampsEventType; //디챔스 종류
  stageType: DchampsStageType;
  startDateTime: Date; //시작일
  endDateTime: Date; //종료일
  dchampsStatusType: DchampsStatusType;

  constructor(dto: DevChampsInfoDto) {
    this.eventType = dto.eventType;
    this.stageType = dto.stageType;
    this.startDateTime = new Date(dto.startDateTime);
    this.endDateTime = new Date(dto.endDateTime);
    this.dchampsStatusType = this.getDchampsState(dto);
  }

  private getDchampsState = (vo: DevChampsInfoDto) => {
    if (
      vo.stageType === 'QUALIFIERS' &&
      DateUtil.getWhetherIncludedInThePeriod(new Date(vo.startDateTime), new Date(vo.endDateTime))
    )
      return 'IN_QUALIFY';

    if (vo.stageType === 'FINALS' && !DateUtil.isPastDate(new Date(vo.startDateTime))) return 'BEFORE_FINAL';

    if (
      vo.stageType === 'FINALS' &&
      DateUtil.getWhetherIncludedInThePeriod(new Date(vo.startDateTime), new Date(vo.endDateTime))
    )
      return 'IN_FINAL';

    return 'END';
  };
}

export default DevChampsInfoListVO;
